{
  "evaluationPublished": "The evaluation for {{respondentEmail}} is ready",
  "evaluationReady": "Your evaluation from {{tenantName}} is ready",
  "selfProfileReady": "Your profile is ready to start",
  "assignmentsSent": "Your questionnaires have been sent",
  "creditsReady": "Your credits are ready",
  "view": "View",
  "start": "Start"
}
